import styled from 'styled-components';

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px;
  text-align: center;
  background: rgba(10, 10, 15, 0.88);
  z-index: 5;

  svg {
    width: 40px;
    height: 40px;
    min-width: 40px;
    min-height: 40px;
    max-width: 40px;
    max-height: 40px;
    position: static;
    transform: none;
  }

  p {
    margin: 0;
    max-width: 280px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
`;
